(() => {
class $6c079809e89f53a1$var$HeaderLine extends HTMLElement {
    constructor(){
        super();
        this.titleElem = this.parentElement.querySelector(".title");
        this.setupLineWidth();
        window.addEventListener("resize", ()=>this.setupLineWidth());
    }
    setupLineWidth() {
        const clientRects = this.titleElem.getClientRects();
        const gap = 20;
        let lineWidth = 0;
        if (this.parentElement.parentElement.nextElementSibling === null) {
            const clientRect = clientRects[0];
            this.style.marginTop = `${clientRect.height * 0.55}px`;
            this.style.right = `${clientRect.width + gap}px`;
            const parentLeft = this.parentElement.parentElement.getBoundingClientRect().left;
            lineWidth = clientRect.left - parentLeft + 80;
        } else {
            const clientRect = clientRects[clientRects.length - 1];
            const holderWidth = this.parentElement.getBoundingClientRect().width;
            const titleWidth = clientRect.width;
            lineWidth = holderWidth - titleWidth - gap;
        }
        if (lineWidth < 0) lineWidth = 0;
        this.style.width = `${lineWidth}px`;
    }
}
function $6c079809e89f53a1$export$be20b5137d71b99d() {
    customElements.define("header-line", $6c079809e89f53a1$var$HeaderLine);
}


class $65a2f7933f315bc9$var$ImageSlider extends HTMLElement {
    constructor(){
        super();
        this.duration = 4000;
        this.loop = true;
        this.navigation = true;
        if (this.attributes["loop"] && this.attributes["loop"].nodeValue === "false") this.loop = false;
        if (this.attributes["navigation"] && this.attributes["navigation"].nodeValue === "false") this.loop = false;
        this.classList.add("activated");
        this.slides = this.querySelectorAll(".slide");
        if (this.slides.length === 0) this.navigation = false;
        const style = document.createElement("style");
        style.textContent = `
        image-slider .slide {
            translate: -100vw 0;
            transition: translate .5s ease-in-out;
        }

        image-slider .slide.active {
            translate: 0 0;
        }

        image-slider .slide.active ~ .slide {
            translate: 100vw 0;
        }

        image-slider .nav-item::before {
            animation-duration: ${this.duration}ms;
        }
        `;
        this.append(style);
        if (this.navigation && this.slides.length > 1) this.setupNavigation();
        this.setSlideActive(0);
    }
    setSlideActive(index) {
        if (this.slides[index]) {
            this.slides.forEach((slide)=>slide.classList.remove("active"));
            this.slides[index].classList.add("active");
            this.currentSlide = index;
        }
        if (this.navigationItems) {
            this.navigationItems.forEach((item)=>item.classList.remove("active"));
            if (this.navigationItems[index]) this.navigationItems[index].classList.add("active");
        }
        if (index < this.slides.length) window.setTimeout(()=>this.setSlideActive(this.currentSlide + 1), this.duration);
        else if (this.loop && index === this.slides.length) this.setSlideActive(0);
    }
    setupNavigation() {
        const navigationHolder = document.createElement("nav");
        navigationHolder.classList.add("navigation");
        this.slides.forEach((_)=>{
            const slideElem = document.createElement("span");
            slideElem.classList.add("nav-item");
            navigationHolder.append(slideElem);
        });
        this.append(navigationHolder);
        this.navigationItems = navigationHolder.querySelectorAll(".nav-item");
    }
}
function $65a2f7933f315bc9$export$ecf32f1b02f9ac7a() {
    customElements.define("image-slider", $65a2f7933f315bc9$var$ImageSlider);
}


class $7acdc80693c24673$var$BlockGrid extends HTMLElement {
    constructor(){
        super();
        // Setup filters
        this.filters = this.filtersAttribute;
        const filterLabels = this.filters.map((filter)=>this.createFilterLabel(filter));
        const filterGroup = document.createElement("section");
        filterGroup.classList.add("filter-group");
        filterGroup.append(...filterLabels);
        if (filterLabels.length > 0) this.append(filterGroup);
        // Setup brands
        this.blocks = this.querySelectorAll(".block");
        const blockGroup = document.createElement("section");
        if (filterLabels.length > 0) {
            this.resultCount = document.createElement("section");
            this.resultCount.classList.add("result-count");
            this.setupResultCountText();
            blockGroup.append(this.resultCount);
        }
        blockGroup.classList.add("block-group");
        blockGroup.append(...this.blocks);
        this.append(blockGroup);
        this.descriptionHolder = this.querySelector(".descriptions");
        this.descriptions = this.querySelectorAll(".descriptions .description");
        this.setBlockVisibility();
    }
    get filtersAttribute() {
        return JSON.parse(this.getAttribute("filters") || "[]");
    }
    get selectedFilters() {
        return this.filters.filter((f)=>f.selected);
    }
    get inactiveBlocks() {
        return [
            ...this.blocks
        ].filter((block)=>!this.hasActiveFilter(block));
    }
    get activeBlocks() {
        return [
            ...this.blocks
        ].filter((block)=>this.hasActiveFilter(block));
    }
    get inactiveDescriptions() {
        return [
            ...this.descriptions
        ].filter((desc)=>!this.hasSelectedFilter(desc));
    }
    setupResultCountText() {
        const resultCount = this.activeBlocks.length;
        const resultText = resultCount > 1 ? "resultaten" : "resultaat";
        if (this.resultCount) this.resultCount.innerHTML = `${resultCount} ${resultText} gevonden`;
    }
    // Check if element is in selected filter
    hasActiveFilter(elem) {
        return this.selectedFilters.every((f)=>elem.dataset.filter.indexOf(f.slug) !== -1);
    }
    // Check if element is in selected filter
    hasSelectedFilter(elem) {
        return this.selectedFilters.some((f)=>elem.dataset.filter.indexOf(f.slug) !== -1);
    }
    // Toggle filter selected
    toggleFilter(filter) {
        this.filters = this.filters.map((f)=>{
            if (f === filter) f.selected = !f.selected;
            return f;
        });
    }
    // Only show active brands
    setBlockVisibility() {
        // Show all elements
        this.blocks.forEach((block)=>block.classList.remove("hidden"));
        this.descriptions.forEach((desc)=>desc.classList.add("hidden"));
        // Hide elements of there are selected filters
        if (this.selectedFilters.length > 0) {
            this.inactiveBlocks.forEach((block)=>block.classList.add("hidden"));
            this.descriptions.forEach((desc)=>desc.classList.remove("hidden"));
            this.inactiveDescriptions.forEach((desc)=>desc.classList.add("hidden"));
            if (this.descriptionHolder) this.descriptionHolder.classList.remove("hidden");
        } else if (this.descriptionHolder) this.descriptionHolder.classList.add("hidden");
        this.setupResultCountText();
    }
    // Setup clickable label
    createFilterLabel(filter) {
        const label = document.createElement("label");
        label.classList.add("filter", "button", "white");
        label.append(filter.name);
        label.addEventListener("click", ()=>{
            label.classList.toggle("active");
            this.toggleFilter(filter);
            this.setBlockVisibility();
        });
        return label;
    }
}
function $7acdc80693c24673$export$84ada64bc6347189() {
    customElements.define("block-grid", $7acdc80693c24673$var$BlockGrid);
}


function $260201d3dbd9a9f2$export$62e4ec31312c380a() {
    const searchForm = document.querySelector(".searchform");
    const searchButton = document.querySelector(".toggle-search");
    const searchField = searchForm.querySelector("input");
    searchButton.addEventListener("mousedown", (evt)=>{
        evt.preventDefault();
        if (document.querySelector("body").classList.contains("mobile-nav-active")) searchForm.submit();
        if (!searchForm.classList.contains("active")) searchField.focus();
        else searchField.blur();
    });
    searchField.addEventListener("focus", ()=>{
        searchForm.classList.add("active");
    });
    searchField.addEventListener("blur", ()=>{
        searchForm.classList.remove("active");
    });
}


function $27fb492e1ac5c472$export$7b7f71765f51ec79() {
    // Setup mobile nav toggle button
    const toggleBtn = document.querySelector(".toggle-mobile-nav");
    toggleBtn.addEventListener("click", ()=>{
        document.querySelector("body").classList.toggle("mobile-nav-active");
    });
    // Add logo to mobile nav
    const mainMenu = document.querySelector(".main-menu");
    const logo = document.querySelector(".main-header .logo");
    mainMenu.prepend(logo.cloneNode());
}


window.addEventListener("DOMContentLoaded", ()=>{
    (0, $65a2f7933f315bc9$export$ecf32f1b02f9ac7a)();
    (0, $7acdc80693c24673$export$84ada64bc6347189)();
    (0, $260201d3dbd9a9f2$export$62e4ec31312c380a)();
    (0, $27fb492e1ac5c472$export$7b7f71765f51ec79)();
});
window.addEventListener("load", ()=>{
    (0, $6c079809e89f53a1$export$be20b5137d71b99d)();
});

})();
//# sourceMappingURL=script.js.map
